import React, { createContext, Suspense, memo } from 'react';
import { Resolver as ResolverController, ResolverState } from '@modelsjs/resolver';
import { useResolver } from './useResolver';
export const Resolver = memo(({ fallback, resolvers, children }) => {
    return (React.createElement(ResolverContext.Provider, { value: new ResolverController(resolvers) },
        React.createElement(Suspense, { fallback: fallback },
            children,
            React.createElement(Wait, null))));
});
export const Wait = memo(({ children }) => {
    const resolver = useResolver();
    if (resolver.state !== ResolverState.Resolving) {
        resolver.run();
    }
    if (resolver.promise) {
        // TODO: implement debug log
        resolver.promise.catch((error) => console.log(error));
        throw resolver.promise;
    }
    return React.createElement(React.Fragment, null, children);
});
export const ResolverContext = createContext(new ResolverController([]));
